import React from 'react';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import clsx from 'clsx';
import { FormLabel } from '@mui/material';

interface DropDownFieldsProps {
    value: string;
    onChange: (value: string) => void;
    options: string[];
    addStyle?: string;
    label: string;
    disabled?: boolean;
    addLabelStyle?: string;
}

const DropDownFields: React.FC<DropDownFieldsProps> = ({ value, onChange, options, addStyle, addLabelStyle, label, disabled = false }) => {
    const handleDropdownChange = (event: SelectChangeEvent<string>) => {
        onChange(event.target.value);
    };

    return (
        <FormControl variant="outlined" sx={{
            borderRadius: 2,
            '.MuiOutlinedInput-root': {
                borderRadius: 0.5,
            }
        }} size="small">


            <FormControl>
                <FormLabel className='!font-inter !text-[12px]'>{label}</FormLabel>
                <Select
                    id={label}
                    value={value}
                    onChange={handleDropdownChange}
                    className={clsx('!font-inter', '!h-[40px]', '!font-normal', '!text-[14px]', '!leading-[18px]', addStyle)}
                    MenuProps={{
                        PaperProps: {
                            sx: {
                                '.MuiMenuItem-root': {
                                    height: '36px',
                                    fontFamily: 'inter, sans-serif',
                                    backgroundColor: 'transparent',
                                    '&:hover': {
                                        backgroundColor: '#F4F8F9 !important',
                                    },
                                },
                                '.MuiMenuItem-root.Mui-selected': {
                                    backgroundColor: 'transparent !important',
                                    '&:hover': {
                                        backgroundColor: '#F4F8F9 !important',
                                    },
                                },
                            },
                        }
                    }}
                    disabled={disabled} // Added disabled prop to Select
                >
                    {options.map(option => (
                        <MenuItem
                            key={option}
                            value={option}
                            className="!font-inter"
                        >
                            {option}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </FormControl>
    );
};

export default DropDownFields;